import { create } from 'zustand';

// TODO(shop-formulas-subscription-refetch-lag-workaround): remove once BE
// fixes the subscription-status propagation delay ticket - this whole
// suppress-and-patch-cache workaround (here + ShopFormulasPage.tsx) can go,
// revert to plain refetch-on-mount.
// BE takes 15+s to reflect a just-added subscription; until this timestamp
// passes, mount-triggered refetches (ShopFormulasPage remounts on every shop
// tab switch) are skipped so they don't clobber the optimistic cache update
// with stale server data. Lives in a module-level Zustand store (not
// component state) because it must survive the unmount/remount itself.
interface ShopFormulasRefetchGuardState {
  refetchSuppressedUntil: number;
  suppressRefetch: (durationMs: number) => void;
  isRefetchSuppressed: () => boolean;
}

export const useShopFormulasRefetchGuard =
  create<ShopFormulasRefetchGuardState>((set, get) => ({
    refetchSuppressedUntil: 0,
    suppressRefetch: (durationMs) =>
      set({ refetchSuppressedUntil: Date.now() + durationMs }),
    isRefetchSuppressed: () => Date.now() < get().refetchSuppressedUntil,
  }));
